<div
  [ngClass]="{
    stretch: stretch,
  }"
  class="phone phone--{{ size }}"
>
  <div class="bazzel">
    <div class="screen" [class.stretch]="stretch">
      <div class="card-phone" [class.stretch]="stretch">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="line"></div>
  <div class="header">
    <div class="sensor-1"></div>
    <div class="sensor-2"></div>
    <div class="sensor-3"></div>
  </div>
  <div class="volume-button"></div>
  <div class="power-button"></div>
</div>
